import React, {useMemo, useRef} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import $ from "jquery";

import CheckIcon from '@mui/icons-material/Check';

import FeatureName from "../../../../visComponents/featureName";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import FeatureThumbnail from "../../../../visComponents/featureThumbnail";
import Config, {IS_LIXIL_SERVERS, IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getCommonCoords, getFeatureCoords, getLayerCenter, navFeatureCLick, zoomCanvasOut} from "../../lookFunctions";
import {addToCart, setCanvasScale, updateCanvasCount} from "../../../../../actions/actionFunctions";
import {getCurrentLayout} from "../../../../appLayout";
import {LOOK_WALLS_ONLY} from "../../../core/constants";

import {enableRelatedFeature, getPropertyToMatchActiveFeature} from "../../lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import LookFeaturePrice from "../lookListFeature/lookFeaturePrice";
import {setWizardSelectedValues} from "../../../../../actions/wizardFunctions";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import LookWizardSectionListFeatureQuantity from "./lookWizardSectionListFeatureQuantity";
import {
  setLookActiveFeature,
  setLookAllWallsTutorial,
  setLookCompatabilityAlert
} from "../../../../../actions/lookFunctions";
import LookAllWallsRadioButton from "../lookAllWallsRadioButton";
import {
  checkForCompatabilityAlert,
  clickOnSimilarFeatures,
  getApplyToLogic,
  getShowMatchRadio,
} from "../../lookNavigationFunctions";
import LookListActiveFeatureMobileButton from "../lookListFeature/lookListActiveFeatureMobileButton";
import {getAnalyticsEcommerceItem} from "../../../../../analyticsEcommerceParams";
import {getCorrectedCenter, shouldZoomPartId, shouldZoomToTheBottom} from "../../../hocs/withZoomToFeature";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import {shouldSkipLock} from "./lookWizardFunctions3";

const LookWizardSectionListFeature = (props) => {

  const {wizardGroup, lookFeature, lookViewType, featureGroup, updateCanvasCount, style, setLookActiveFeature, navItems,
    isMobile, addToCart, qtActiveCategory, setCanvasScale, wizardSelectedValues, wizardActiveStep, setWizardSelectedValues,
    imageCanvas, maxClickCountReached, updateLookCartItem, setLookCompatabilityAlert, isLixil, groheActiveFeatureQuantity,
    lookAllWallsTutorial, setLookAllWallsTutorial, isPhoneNumberValidated, lookLockedTutorial, isEncore, canvasScale,
    isAllWallsTutorialItem, wizardStepIndex} = props;

  const featureElement = useRef();

  const featureIsLocked = useMemo(() => {
    if (shouldSkipLock({wizardGroup})) {
      return false
    }
    return getFeatureIsLocked(lookFeature)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookFeature, wizardGroup, isPhoneNumberValidated]);

  const applyWizardItemClick = async (zoomFeature, quantityItems) => {
    setWizardSelectedValues({
      [wizardActiveStep]: {
        wizardGroup,
        selectedFeature: lookFeature,
        partId: lookFeature.partId,
        singleFeature: navItems.length === 1,
        quantity: groheActiveFeatureQuantity,
        quantityItems, // undefined is also ok
      }
    });

    // if (wizardGroup && wizardGroup.skipLockDontApply) { // removed, we need always to apply feature on the look journey
    //   return false
    // }

    const layout = getCurrentLayout();
    if (zoomFeature) {

      const parent = featureGroup || zoomFeature.getParent();
      Analytics.sendEcommerceEvent("select_item", {
        item_list_id: zoomFeature.partId,
        item_list_name: parent.dbName || parent.partName || "",
        items: [getAnalyticsEcommerceItem(zoomFeature, 1)],
      });

      const featureLabel = Analytics.getSkuForAnalytics(zoomFeature);
      const analyticsLabel = LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardListFeature + featureLabel;
      Analytics.sendClickEvent(analyticsLabel);

      const positionInList = navItems ? navItems.findIndex(navItem => navItem.part?.dbFeature?.id === lookFeature.dbFeature.id) : null;
      setLookActiveFeature(zoomFeature, positionInList); // to set feature screen options // allow for look journey too

      if (showMatchRadio) { // before nav feature click
        const applyToLogic = getApplyToLogic(lookFeature);
        if (applyToLogic && Array.isArray(applyToLogic.currentApplyToArray) && applyToLogic.currentApplyToArray.length) {
          await clickOnSimilarFeatures(zoomFeature, applyToLogic, true, featureIsLocked);
        }
      }
      navFeatureCLick(zoomFeature, true, !featureIsLocked);
      enableRelatedFeature(zoomFeature, addToCart, qtActiveCategory);

      // const parent = zoomFeature.getParent();
      // if (parent.disabled) {
      //   parent.disabled = false;
      //   parent.disabledClick();
      // }
      if (wizardGroup.multipleAddToCart) {
        return
      }
      updateCanvasCount();
      if (imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom && !LOOK_WALLS_ONLY.includes(zoomFeature.partId)
        && shouldZoomPartId(zoomFeature.partId, isMobile)) {
        if (zoomFeature.matchesMetaForArrayOfConditions(parent.getArrayOfConditions())) {
          const commonCoords = getFeatureCoords(zoomFeature, true) || getCommonCoords(parent, zoomFeature, imageCanvas.current.canvas);
          if (commonCoords && Object.keys(commonCoords).length) {
            const {center, scale} = getCorrectedCenter(
              getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile),
              null, zoomFeature, imageCanvas, isMobile
            );
            imageCanvas.current.pinchZoom.zoomToCenter(center, scale, false, layout.partIdExistInQtCategory(zoomFeature.partId));
            setCanvasScale(imageCanvas.current.pinchZoom.options.tapZoomFactor)
          }
        }
      } else if (canvasScale !== 1) {
        zoomCanvasOut(imageCanvas, setCanvasScale);
        if (shouldZoomToTheBottom(zoomFeature.partId)) {
          $("html, body").animate({scrollTop: document.body.scrollHeight}, 500);
        }
      }
      if (!lookAllWallsTutorial.finished && showMatchRadio && !featureIsLocked && !lookFeature.notAvailableInVisualizer
        && featureElement && featureElement.current && !isEncore) {
        const applyToLogic = getApplyToLogic(lookFeature);
        if (applyToLogic) {
          setLookAllWallsTutorial({
            visible: true,
            // withGrid: navItems.length === 1,
            // positionInList,
            lookFeature,
            top: featureElement.current.getBoundingClientRect().top,
            left: featureElement.current.getBoundingClientRect().left,
            height: style.height,
            width: style.width,
            // firstLockedIndex,
            // firstUnlockedIndex,
          })
        }
      }
    }
    updateLookCartItem(zoomFeature);
  }

  // const [canRender, setCanRender] = useState(false);
  const listFeatureClick = (event, quantityItems) => {
    if (event.target.closest(".look-icon--delete") || event.target.closest(".gm-ios-checkbox") || lookLockedTutorial.visible || isAllWallsTutorialItem) {
      return
    }
    if (Config.isDevMode() && lookFeature) {
      console.log("lookFeature", lookFeature, lookFeature.metaData);
    }
    let zoomFeature = lookFeature;
    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    const compatabilityLogic = isLixil ? [] : checkForCompatabilityAlert(zoomFeature);
    if (compatabilityLogic.length) {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookShowCompatabilityAlert);
      setLookCompatabilityAlert({
        visible: true,
        compatabilityLogic,
        clickedFeature: zoomFeature,
        applyFunction: applyWizardItemClick.bind(this, zoomFeature, quantityItems) // always apply features from this popup
      });
      return false
    }

    applyWizardItemClick(zoomFeature, quantityItems);
  }

  // const realFeatureGroup = (featureGroup || lookFeature.getParent())
  // const activeFeature = realFeatureGroup.activeNotInVisualizerFeature || realFeatureGroup.activeFeature;
  let isActive = false;
  if (wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].selectedFeature) {
    const propToMatch = getPropertyToMatchActiveFeature(wizardSelectedValues[wizardActiveStep].selectedFeature);
    isActive = lookFeature.dbFeature[propToMatch] === wizardSelectedValues[wizardActiveStep].selectedFeature.dbFeature[propToMatch]
  }
  const nameLength = IS_PRODUCT_JOURNEY ? 40 : 500;

  const showMatchRadio = getShowMatchRadio(lookFeature);
  const showAllWalls = isActive && showMatchRadio;

  return (
    <li className={"lm-feature lm-feature--type-"
      + lookViewType + " lm-feature--wizard-type-" + wizardGroup.nodeType
      + (isAllWallsTutorialItem ? " lm-feature--all-walls-tutorial" : "")
      + (featureIsLocked ? " lm-feature--locked" : " lm-feature--unlocked")
      + (isActive ? " lm-feature--active" : "")}
        style={lookLockedTutorial.visible && !isMobile ? {...style, width: style.width - 8} : style}
        ref={featureElement}
        onClick={listFeatureClick}>
      <div className="lm-feature__thumbnail">
        {isActive ? (IS_PRODUCT_JOURNEY && isMobile) ? (
          <LookListActiveFeatureMobileButton lookFeature={lookFeature} isWizard={true} isActive={true}/>
        ) : (
          <div className="lm-feature__checkmark">
            <CheckIcon fontSize="small"/>
          </div>
        ) : null}
        <FeatureThumbnail feature={lookFeature} dbFeatureId={lookFeature.dbFeature.id}/>
        {showAllWalls ? <LookAllWallsRadioButton lookFeature={lookFeature}
                                                 showTutorialToolTip={isAllWallsTutorialItem}
                                                 viewType={lookViewType}
                                                 type="small"/> : null}
      </div>
      <div className={"lm-feature__content" + (wizardGroup.hidePriceNoCart && !featureIsLocked ? " lm-feature__content--no-price" : "")}>
        {wizardGroup.hidePriceNoCart && !featureIsLocked ? null : (
          <div className="lm-feature__content-price order-3">
            <LookFeaturePrice lookFeature={lookFeature}
                              className="lm-feature__content-price-text"
                              wizardGroup={wizardGroup}/>
          </div>
        )}
        {wizardGroup.multipleAddToCart && !lookFeature.dbFeature.hideQuantity && !IS_PRODUCT_JOURNEY && (lookViewType === 1) ? (
          <div className="lm-feature__content-price order-4">
            <LookWizardSectionListFeatureQuantity lookFeature={lookFeature}
                                                  wizardStepIndex={wizardStepIndex}
                                                  listFeatureClick={listFeatureClick}/>
          </div>
        ) : null}
        <span className="lm-feature__content-name order-1">
          <FeatureName feature={lookFeature} useCollectionName={true}/>
        </span>
        {(wizardGroup.multipleAddToCart && !IS_PRODUCT_JOURNEY) || !IS_LIXIL_SERVERS ? null : (
          <p className="lm-feature__content-description order-2">
            <FeatureName feature={lookFeature} maxLength={nameLength}/>
          </p>
        )}
      </div>
    </li>
  )
};

LookWizardSectionListFeature.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  featureGroup: PropTypes.object,
  viewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  style: PropTypes.object,
  imageCanvas: PropTypes.object.isRequired,
  maxClickCountReached: PropTypes.func,
  updateLookCartItem: PropTypes.func,
  navItems: PropTypes.array,
  isAllWallsTutorialItem: PropTypes.bool,
  wizardStepIndex: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {lookViewType, lookAllWallsTutorial, lookLockedTutorial} = store.lookState;
  const {isMobile} = store.serverState;
  const {activePreset, bvPresets, canvasScale} = store.bathroomVisualizerState;
  const {qtActiveCategory} = store.qtState;
  const {wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {cabinetsApplyTo} = store.navigationState;
  const {isLixil, isEncore} = store.fabricatorState;
  const {groheActiveFeatureQuantity} = store.groheState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    lookViewType,
    isMobile,
    activePreset,
    bvPresets,
    qtActiveCategory,
    canvasScale,
    wizardSelectedValues,
    wizardActiveStep,
    cabinetsApplyTo,
    isLixil,
    groheActiveFeatureQuantity,
    lookAllWallsTutorial,
    isPhoneNumberValidated,
    lookLockedTutorial,
    isEncore,
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
  addToCart,
  setCanvasScale,
  setWizardSelectedValues,
  setLookActiveFeature,
  setLookCompatabilityAlert,
  setLookAllWallsTutorial,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookWizardSectionListFeature)
)
